/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PopulateSoleraUserRequest } from '../models/PopulateSoleraUserRequest';
import type { SuccessSoleraUserResponse } from '../models/SuccessSoleraUserResponse';
import type { SuccessVoid } from '../models/SuccessVoid';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SoleraControllerService {

    /**
     * Populates the user's profile with data from the Solera handover process.
     * @param requestBody
     * @returns SuccessVoid OK
     * @throws ApiError
     */
    public static populateSoleraUser(
        requestBody: PopulateSoleraUserRequest,
    ): CancelablePromise<SuccessVoid> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/integrations/solera/populate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

    /**
     * Retrieves the authenticated user's Solera information.
     * @returns SuccessSoleraUserResponse OK
     * @throws ApiError
     */
    public static retrieveUserInfo(): CancelablePromise<SuccessSoleraUserResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/integrations/solera/user-info',
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

}
